/****
 * Provide lazy-loading methods for images that are build using the
 * HTML5 picture tag and sourceset attributes.
 *
 * The <picture> element should have the class "lazy-load" and the individual
 * <source> and <img> elements should use "data-src" and "data-srcset" attributes
 * instead of "src" and "srcset".
 *
 * Example:
 * 	$('picture.lazy-load').lazyload(); // Run this when ready to load images
 *
 * Markup should look like this:
 * <picture class="lazy-load">
 *   <source data-src="example-large.jpg" media="(min-width: 1024px)">
 *   <source data-srcset="example-medium.jpg" media="(min-width: 640px)">
 *   <img data-srcset="example-small.jpg" alt="Alt text">
 * </picture>
 *
 ****/
define([
	'jquery',
	], function($) {

		var PLUGIN_IDENTIFIER = "lazyload";
		var lazyload = function( element, options ) {
			this.element = element;
			this.$element = $(this.element);
			this.options = options;
		};

		lazyload.prototype = {
			defaults: { },

			/**
			 * Trigger lazy loading
			 * $('picture.lazy-load').lazyload();
			 **/
			init : function() {
				var self = this;

				// Check the HTML tag type we are lazy loading
				var children = self.$element.children("[data-src],[data-srcset]");
				if(children.length > 0){
					// <picture> tags have child elements of <source> and <img>
					children.each(function(idx) {
						self.switchSource($(this));
					});
				} else {
					// <img> tags don't have children
					self.switchSource(self.$element);
				}
				// Trigger main.update again since srcset has changed
				main.update();

				return self;
			},

			/**
			 * Switch the source of an individual elememnt
			 * so that the image will load
			 **/
			switchSource : function($el) {

				// Rewrite data-src="" to src=""
				if($el.data('src')) {
					$el.attr('src',$el.data('src'));
					return true;
				}

				// Rewrite data-src="" to src=""
				if($el.data('srcset')) {
					$el.attr('srcset',$el.data('srcset'));
					return true;
				}
			}
		};

		lazyload.defaults = lazyload.prototype.defaults;

		// prevent duplicate instantiation
		$.fn.lazyload = function(options) {
			return this.each(function() {
				var instance = $(this).data(PLUGIN_IDENTIFIER);
				if(!instance) {
					instance = new lazyload(this, options).init();
					$(this).data(PLUGIN_IDENTIFIER,instance);
				}
			});
		};
	}
);